import { useEffect, useState } from "react";
import useApi from "./useApi";

interface HubSpotConfig {
  id: number;
  displayName: string;
  portalName: string;
  hubId: string;
  enabled: boolean;
  pushTranscripts: boolean;
}

export default function useHubSpotConfigs() {
  const [items, setItems] = useState<HubSpotConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.admin.get("HubSpot/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.admin]);

  return { items, loading };
}
